import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

export const TRANSACTIONS_QUERY_KEY = ["transactions"] as const;

type TransactionType = components["schemas"]["TransactionType"];
type TransactionSortKey = components["schemas"]["TransactionSortKey"];
type SortOrder = components["schemas"]["SortOrder"];

export type ListTransactionsQuery = {
  include_deleted?: boolean;
  account_id?: string[];
  transaction_type?: TransactionType;
  since?: string;
  until?: string;
  sort_key?: TransactionSortKey;
  sort_order?: SortOrder;
  limit?: number;
  offset?: number;
};

export function useTransactions(params: ListTransactionsQuery = {}) {
  const client = useApiClient();
  return useQuery({
    queryKey: [...TRANSACTIONS_QUERY_KEY, params],
    queryFn: async () => {
      const { data, error } = await client.GET("/api/transactions", {
        params: { query: params },
      });
      if (error !== undefined) {
        throw new Error("Failed to list transactions");
      }
      return data;
    },
  });
}
